module.exports = __webpack_public_path__ + "img/01.b3a26302.png";